import * as yup from 'yup';

import { allowedDriverAge } from '../../../helpers/DateHelper';
import { ZONE_IDS } from '../YourTravelForm/values';

export const yourTravelCoverFormYupSchema = {
  excess: yup.array().of(yup.number()).required(),
  carHireExcess: yup.boolean().nullable()
    .when(['destinationZone', 'dob'], (destinationZone, dob, schema) => {
      return (destinationZone === ZONE_IDS['Europe'] && allowedDriverAge(dob)) ?
        schema.required('Car Hire Excess answer is required') : schema;
    }),
  winterSportsExcess: yup.boolean().nullable().required('Winter sports answer is required'),
  businessExpenseExcess: yup.boolean().nullable().required('Business travel answer is required'),
  dataProtectionConsent: yup.boolean()
    .oneOf([true], 'You must accept the Terms and Conditions'),
  chubbTOBConsent: yup.boolean()
    .oneOf([true], 'You must accept the Chubb Terms of Business and Privacy Policy.')
};

export default yourTravelCoverFormYupSchema;
